import Environment from 'Environment';
import RoutePaths from 'RoutePaths';

const B2cPolicies = {
  names: {
    externalUser: 'B2C_1A_signup_signin_external_user',
    internalUser: 'B2C_1A_signup_signin_internal_user',
    passwordReset: 'B2C_1A_password_reset',
    changeSigninEmail: 'B2C_1A_change_signin_email_external_user',
    editPhoneNumber: 'B2C_1A_profile_edit_phone_number'
  },
  authorities: {
    externalUser: {
      authority: Environment.MsalExternalUserAuthority
    },
    internalUser: {
      authority: Environment.MsalInternalUserAuthority
    },
    passwordReset: {
      authority: Environment.MsalPasswordResetAuthority
    },
    changeSigninEmail: {
      authority: Environment.MsalChangeSigninEmailAuthority
    },
    editPhoneNumber: {
      authority: Environment.MsalEditPhoneNumberAuthority
    },
    idPortenValidation: {
      authority: Environment.IdPortenValidateAuthority
    }
  }
};

const B2cScopes = [Environment.MsalScope];

const PasswordResetReturnUri = `${window.location.origin}${RoutePaths.passwordReset}`;
const ChangeSigninEmailReturnUri = window.location.origin;
const EditPhoneNumberReturnUri = window.location.origin;
const ProfileValidateReturnUri = `${window.location.origin}${RoutePaths.profileValidate}`;
const { StatsforvalterenDomainHint } = Environment;

export {
  B2cPolicies,
  B2cScopes,
  PasswordResetReturnUri,
  ChangeSigninEmailReturnUri,
  EditPhoneNumberReturnUri,
  ProfileValidateReturnUri,
  StatsforvalterenDomainHint
};
